import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CodeTypeModel }                from '../core/models/code-type';
import { CommunicationCenterComponent } from './communication-center.component';
import { CommunicationCenterService }   from './communication-center.service';
import { CustomerSourceModel }          from '../company-lists/typings/customer-source';

export const CommunicationCenterStates : Array<NgHybridStateDeclaration> = [
  {
    component: CommunicationCenterComponent,
    name     : 'app.communication-center',
    resolve  : [
      {
        deps     : [ CommunicationCenterService ],
        resolveFn: ( communicationCenterService : CommunicationCenterService ) : ng.IPromise<Array<CodeTypeModel>> => communicationCenterService.getTypes(),
        token    : 'communicationTypes'
      },
      {
        deps     : [ CommunicationCenterService ],
        resolveFn: ( communicationCenterService : CommunicationCenterService ) : ng.IPromise<Array<CodeTypeModel>> => communicationCenterService.getContactTypes(),
        token    : 'contactTypes'
      },
      {
        deps     : [ CommunicationCenterService ],
        resolveFn: ( communicationCenterService : CommunicationCenterService ) : ng.IPromise<Array<CustomerSourceModel>> => communicationCenterService.getCustomerSources(),
        token    : 'customerSources'
      }
    ],
    url: '/communication-center'
  }
];
